/* Lane S (2026-10-02): search results page helpers, loaded by sections/main-search.liquid.
 * 1. Range and category buckets (snippets/upsb-facet-buckets.liquid): a bucket checkbox has no name; checking it
 *    enables the hidden inputs that carry its member values, so facets.js (which reads the whole form 800 ms after the
 *    input event) submits them. Listening on the document survives facets.js replacing the filter markup.
 * 2. "More filters": the desktop rail shows 8 filter groups; the button shows the rest. A rest group with an active
 *    value opens the full list on load.
 * 3. No result: close part numbers (the query cut back a character at a time, at most 4 lookups) and guides, from the
 *    predictive search endpoint. */
(function () {
  document.addEventListener(
    'change',
    function (event) {
      var box = event.target;
      if (!box.classList || !box.classList.contains('upsb-bucket')) return;
      var item = box.closest('.upsb-fb__item');
      if (!item) return;
      item.querySelectorAll('input[data-upsb-bucket-value]').forEach(function (input) {
        input.disabled = !box.checked;
      });
    },
    true
  );

  function moreFilters() {
    var wrap = document.getElementById('FacetsWrapperDesktop');
    var btn = wrap && wrap.querySelector('[data-upsb-f-more]');
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    var set = function (open) {
      wrap.classList.toggle('upsb-f--all', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    btn.addEventListener('click', function () {
      set(!wrap.classList.contains('upsb-f--all'));
    });
    var activeExtra = Array.prototype.some.call(wrap.querySelectorAll('.upsb-f-extra .facets__selected'), function (el) {
      return !el.classList.contains('hidden');
    });
    if (activeExtra) set(true);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function suggest(q, types, limit) {
    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var url = base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=' + types + '&resources[limit]=' + limit +
      '&resources[options][unavailable_products]=last';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return (j && j.resources && j.resources.results) || {}; })
      .catch(function () { return {}; });
  }

  function emptyPage() {
    var box = document.querySelector('[data-upsb-empty]');
    if (!box || box.dataset.bound) return;
    box.dataset.bound = '1';
    var q = (box.getAttribute('data-q') || '').trim();
    var close = box.querySelector('[data-upsb-close]');
    var status = box.querySelector('[data-upsb-close-status]');
    var none = document.documentElement.lang && document.documentElement.lang.indexOf('fr') === 0
      ? 'Aucun numéro proche trouvé.' : 'No close part number found.';
    if (status && status.getAttribute('data-none')) none = status.getAttribute('data-none');

    // Close part numbers: the compact key cut back one character at a time (SMT1500RM2UCX -> SMT1500RM2UC ...),
    // never below 3 characters or 60 % of the key.
    var key = q.replace(/[\s\-_.\/]+/g, '');
    var hasDigit = /\d/.test(key) && /[a-z]/i.test(key);
    var tries = [];
    if (hasDigit) {
      var min = Math.max(3, Math.ceil(key.length * 0.6));
      for (var n = key.length - 1; n >= min && tries.length < 4; n--) tries.push(key.slice(0, n));
    } else if (q) {
      tries.push(q.split(/\s+/)[0]);
    }
    (function next(i) {
      if (i >= tries.length) {
        if (status) status.textContent = none;
        return;
      }
      suggest(tries[i], 'product', 6).then(function (res) {
        var list = (res.products || []).filter(function (p) { return p && p.url; });
        if (!list.length) return next(i + 1);
        close.innerHTML = '<ul class="upsb-sr-empty__list list-unstyled" role="list">' + list.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=96';
          return '<li><a class="upsb-sr-empty__item" href="' + esc(p.url) + '">' +
            '<span class="upsb-ps__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : '') + '</span>' +
            '<span class="upsb-sr-empty__item-title">' + esc(p.title) + '</span></a></li>';
        }).join('') + '</ul>';
      });
    })(0);

    // Guides and pages that mention the query.
    var guides = box.querySelector('[data-upsb-guides]');
    var glist = box.querySelector('[data-upsb-guides-list]');
    if (guides && glist && q) {
      suggest(q, 'page,article', 4).then(function (res) {
        var items = [].concat(res.pages || [], res.articles || []).slice(0, 4);
        if (!items.length) return;
        glist.innerHTML = items.map(function (it) {
          return '<li><a class="link underlined-link" href="' + esc(it.url) + '">' + esc(it.title) + '</a></li>';
        }).join('');
        guides.hidden = false;
      });
    }
  }

  function init() {
    moreFilters();
    emptyPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
